
import { useState } from 'react';
import { DEFAULT_PERMISSIONS, type PermissionsState } from '@/types/permissions';

/**
 * Hook for managing permissions state
 */
export const usePermissionsState = () => {
  const [permissions, setPermissions] = useState<PermissionsState>(DEFAULT_PERMISSIONS);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [error, setError] = useState<string | undefined>(undefined);
  const [subscriptionSource, setSubscriptionSource] = useState<'stripe' | 'admin_override' | 'fallback' | undefined>(undefined);
  const [upgradeInProgress, setUpgradeInProgress] = useState(false);

  return {
    permissions,
    setPermissions,
    isRefreshing,
    setIsRefreshing,
    error,
    setError,
    subscriptionSource,
    setSubscriptionSource,
    upgradeInProgress,
    setUpgradeInProgress,
  };
};
